export default "__VITE_ASSET__5c6863f8__"